import * as R from "ramda";
import { findSite } from "common/functions/sites";
import { Context } from "common/types/context";
import { type Filter } from "common/types/filters";
import { isAdminUserType } from "common/types/users";
import { getAllChildSiteForGroupSites } from "common/widgets/site-selector/functions";

export const getDefaultFilter = (filters: Filter[]): Filter | undefined =>
  filters?.find((filter) => filter.isDefault);

export const hasPermissionToViewFilter = (context: Context, filter: Filter) => {
  const { role, userTypes, sites: allSites } = context;
  const { roleIds = [], sites = [], shared } = filter;

  const accessibleFilterSites = R.uniq(
    getAllChildSiteForGroupSites(sites, context.sites).concat(sites),
  );

  const canViewByRoles = !roleIds.length || roleIds.includes(role.id);
  const canViewBySites = accessibleFilterSites.some(
    (filterSite) => !!findSite(filterSite, allSites),
  );

  return (
    !shared ||
    ((isAdminUserType(userTypes) || canViewByRoles) && canViewBySites)
  );
};
